import type { Registry as Services } from '@ember/service';
import type { IntlContract } from 'shared-react/lumen';

/**
 * Translates ember-intl into shared-react's IntlContract, so mounted React
 * components format messages through lumen's translations without the
 * package needing a Lokalise project of its own.
 */
export default function createIntl(intl: Services['intl']): IntlContract {
  return {
    locale: intl.primaryLocale ?? 'en',
    formatMessage: ({ defaultMessage, id }, values): string => {
      const key = String(id);
      const options = values as Parameters<Services['intl']['t']>[1];

      return intl.exists(key)
        ? intl.t(key, options)
        : intl.formatMessage(defaultMessage ?? key, options);
    },
  };
}
